module.exports = __webpack_public_path__ + "static/media/hash.c191fa16.svg";